<!-- =========================================================================================
  File Name: ProjectEdit.vue
  Description: Project Edit Page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/project/pixinvent
========================================================================================== -->

<template>
  <div id="page-project-edit">

    <vs-alert color="danger" title="Project Not Found" :active.sync="project_not_found">
      <span>Project record with id: {{ $route.params.projectId }} not found. </span>
      <span>
        <span>Check </span><router-link :to="{name:'page-project-list'}" class="text-inherit underline">All Projects</router-link>
      </span>
    </vs-alert>

    <vx-card v-if="project_data">

      <div slot="no-body" class="tabs-container px-6 pt-6">

        <vs-tabs v-model="activeTab" class="tab-action-btn-fill-conatiner">
          <vs-tab label="General" icon-pack="feather" icon="icon-project">
            <div class="tab-text">
              <project-edit-tab-general class="mt-4" :data="project_data" />
            </div>
          </vs-tab>
          <vs-tab label="Information" icon-pack="feather" icon="icon-info">
            <div class="tab-text">
              <project-edit-tab-information class="mt-4" :data="project_data" />
            </div>
          </vs-tab>
          <vs-tab label="Social" icon-pack="feather" icon="icon-share-2">
            <div class="tab-text">
              <project-edit-tab-social class="mt-4" :data="project_data" />
            </div>
          </vs-tab>
        </vs-tabs>

      </div>

    </vx-card>
  </div>
</template>

<script>
import ProjectEditTabGeneral     from './ProjectEditTabGeneral.vue'
import ProjectEditTabInformation from './ProjectEditTabInformation.vue'
import ProjectEditTabSocial      from './ProjectEditTabSocial.vue'

// Store Module
import moduleProjectManagement from '@/store/project-management/moduleProjectManagement.js'

export default {
  components: {
    ProjectEditTabGeneral,
    ProjectEditTabInformation,
    ProjectEditTabSocial
  },
  data () {
    return {
      project_data: null,
      project_not_found: false,

      /*
        This property is created for fetching latest data from API when tab is changed

        Please check it's watcher
      */
      activeTab: 0
    }
  },
  watch: {
    activeTab () {
      this.fetch_project_data(this.$route.params.projectId)
    }
  },
  methods: {
    fetch_project_data (projectId) {
      this.$store.dispatch('projectManagement/fetchProject', projectId)
        .then(res => { this.project_data = res.data })
        .catch(err => {
          if (err.response.status === 404) {
            this.project_not_found = true
            return
          }
          console.error(err) 
        })
    }
  },
  created () {
    // Register Module ProjectManagement Module
    if (!moduleProjectManagement.isRegistered) {
      this.$store.registerModule('projectManagement', moduleProjectManagement)
      moduleProjectManagement.isRegistered = true
    }
    this.fetch_project_data(this.$route.params.projectId)
  }
}

</script>
